import {ClsErrores2} from './cls-errores';

export class ClsCliente {
  Offline?: boolean;
  accessToken?: string;
  admin?: boolean;
  caducoSesion?: boolean;
  cambioIp?: boolean;
  email?: string;
  emailAdmin?: string;
  errores?: ClsErrores2;
  expiresIn?: string;
  fechaVigencia?: string;
  idEmpresa?: bigint;
  idLicencia?: bigint;
  idUsuario?: bigint;
  idUsuarioAdmin?: bigint;
  licenciaEstudiantil?: boolean;
  limitePptoPu?: ClsLimites;
  mensajeComunicado?: string;
  name?: string;
  noTieneVigencia?: boolean;
  numeroLicencia?: number;
  oauthExpireIn?: number;
  otraSesionActiva?: boolean;
  permiteOffline?: boolean;
  picture?: string;
  razonSocial?: string;
  refreshToken?: string;
  sesion?: bigint;
  tokenCaducado?: boolean;
  logTime?: string;
  modoLogin?: string;
}

export class ClsLimites {
  TipoLicencia: string;
  TotalBasicos: number;
  TotalCatalogo: number;
  TotalConceptos: number;
  TotalInsumos: number;
  TotalMaestrosLibresEscritura: number;
  TotalMaxPorPptoCompartido: number;
  TotalPresupuestos: number;
  errores: ClsErrores2;
}
